import { SxProps } from '@mui/material';

export const CountSx: SxProps = {
  fontSize: '24px',
  marginTop: 0,
  lineHeight: 1
};

export const ZeroCountSx: SxProps = {
  fontSize: '24px',
  color: '#d32f2f',
  marginTop: 0,
  lineHeight: 1
};

export const CountContainerSx: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 1,
  flexWrap: 'nowrap'
};

export const SpinnerSx: SxProps = {
  color: 'grey.500',
  width: '20px !important',
  height: '20px !important'
}; 
